import * as type from "../types";
import { post, put } from "../../config/Requests";
import t from "../../languages/pl";
import { stopLoader, getFirstWelcomeNotification, openSnackbarInfoDispatch, openSnackbarWarning, changeRodoAcceptation } from './requestAction';
import {
    setLogin,
    removeLogin,
    removeUserSubordination,
    removeUserRole,
    removeToken,
    setToken,
    removeUsername,
    setUsername,
    setUserSubordination,
    setUserRole,
    setGpsEnabled,
    setIsPkp,
    removeGpsEnabled,
    removeIsPkp, removeRodo
} from '../../config/sessionData';
import { authLogInRoute, authForgotPasswordRoute,
    settingsUsernameChangeRoute, settingsChangePasswordRoute, forcePasswordRoute } from '../../config/routes';

import instance from "../../config/axiosConfig";
import { getToken } from '../../config/sessionData';
import { tokenIdentifier } from '../../utils/staticData';


export const logIn = (username, password) => {
    return dispatch => {
        post(
            dispatch,
            authLogInRoute,
            {
                login: username,
                password: password
            },
            (response) => {
                dispatch(authSucceed(
                  response.data[1].token,
                  response.data[1].podrzedny,
                  response.data[1].typ_uzytkownika,
                  username,
                  response.data[1].gps,
                  response.data[1].wymus_haslo,
                  response.data[1].pkp));
                dispatch(assignUsername(response.data[1].uzytkownik));
                dispatch(changeRodoAcceptation(response.data[1].rodo));
                dispatch(setUserBlocked(false));
                getFirstWelcomeNotification(dispatch);
                dispatch({
                    type: type.CLOSE_WELCOME_DIALOG,
                    value: true
                });
            },
            (error) => {
                if(error && error.status && error.status === 423)
                    dispatch(setUserExpired(true));
                stopLoader(dispatch);
                dispatch({ type: type.AUTH_FAILED });
                if(error && error.status && error.status === 403)
                    dispatch(setUserBlocked(true));
                stopLoader(dispatch);
                dispatch({ type: type.AUTH_FAILED });
            }
        );
    };
};

export const forgotPassword = (username, email) => {
    return dispatch => {
        post(
            dispatch,
            authForgotPasswordRoute,
            {
                email: email,
                login: username
            },
            () => {},
            () => {
                stopLoader(dispatch);
            }
        );
    };
};

export const usernameChange = (username) => {
    return dispatch => {
        put(
            dispatch,
            settingsUsernameChangeRoute,
            null,
            {nazwa: username},
            () => {
                openSnackbarInfoDispatch(dispatch, t.usernameHasBeenChanged);
                dispatch(assignUsername(username));
            }
        );
    };
};

export const passwordChange = (oldPassword, newPassword) => {
    return dispatch => {
        let config = {
            headers: { [tokenIdentifier]: getToken() },
            params: {}
        };
        const data = {
            stare_haslo: oldPassword,
            nowe_haslo: newPassword
        };

        instance
        .post(settingsChangePasswordRoute, data, config)
        .then(() => {
            openSnackbarInfoDispatch(dispatch, t.passwordHasBeenChanged);
        })
        .catch(error => {
            if (!!error && !!error.response && !!error.response.status && error.response.status === 409) {
                openSnackbarWarning(dispatch, error.response.data);
            }
        });
    };
};

export const logout = () => {
    clearUserDataMemory();
    window.location.replace('/');

    return dispatch => {
        dispatch({
            type: type.LOGOUT
        });
    };
};

export const authError = () => {
    clearUserDataMemory();
    return dispatch => {
        dispatch({
            type: type.AUTH_FAILED
        });
    };
};

export const authSucceed = (token, isSubordinate, role, username, isGpsEnabled, forcePasswordChange, pkp) => {
    if(role === 'podadmin'){
        isSubordinate = false;
    }
    setToken(token);
    setLogin(username);
    setGpsEnabled(isGpsEnabled);
    setUserSubordination(isSubordinate);
    setUserRole(role);
    setIsPkp(pkp);
    return {
        type: type.AUTH_SUCCEEDED,
        value: token,
        noAdmin: isSubordinate,
        role: role,
        login: username,
        isGpsEnabled,
        forcePasswordChange,
        pkp
    };
};

export const assignUsername = (username) => {
    setUsername(username);
    return {
        type: type.ASSIGN_USERNAME,
        value: username
    };
};

function clearUserDataMemory() {
    removeGpsEnabled();
    removeIsPkp();
    removeRodo();
    removeToken();
    removeUsername();
    removeUserSubordination();
    removeUserRole();
    removeLogin();
}

const setUserBlocked = (value) => {
    return {
        type: type.SET_USER_BLOCKED,
        value: value
    };
};

const setUserExpired = (value) => {
    return {
        type: type.SET_USER_EXPIRED,
        value: value
    };
};

export const forcePassword = (newPassword) => {
    return dispatch => {
        let config = {
            headers: { [tokenIdentifier]: getToken() },
            params: {}
        };
        const data = {
            nowe_haslo: newPassword
        };

        instance
            .post(forcePasswordRoute, data, config)
            .then(() => {
                dispatch({
                    type: type.SET_FORCE_PASSWORD_CHANGE,
                    value: false
                });
                dispatch({
                    type: type.SET_OPEN_CONFIRMED_FORCED_PASSWORD_DIALOG,
                    value: true
                });
            }
            )
            .catch(error => {
                if (!!error && !!error.response && !!error.response.status && error.response.status === 409) {
                    dispatch({
                        type: type.SET_REPEATED_PASSWORD,
                        value: true
                    });
                    dispatch({
                        type: type.FORCE_PASSWORD_CHANGE_FAILED_MESSAGE,
                        value: error.response.data
                    });
                }
            });
    };
};
